import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { cn } from "../../../lib/utils";
import { DocsSidebar } from "./DocsSidebar";

interface DocsMobileNavProps {
  className?: string;
}

export function DocsMobileNav({ className }: DocsMobileNavProps) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close mobile nav on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className={cn(
          "md:hidden fixed top-4 left-4 z-50 p-2 bg-[var(--su-bg-secondary)] border border-[var(--su-border-primary)] text-[var(--su-text-primary)]",
          className,
        )}
        aria-label="Open navigation"
      >
        <Menu className="w-6 h-6" />
      </button>

      {isOpen && (
        <>
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={() => setIsOpen(false)}
          />

          {/* Sidebar */}
          <div
            className={cn(
              "fixed left-0 top-0 h-full w-64 bg-[var(--su-bg-secondary)] border-r border-[var(--su-border-primary)] z-50 transform transition-transform md:hidden",
              isOpen ? "translate-x-0" : "-translate-x-full",
            )}
          >
            <div className="flex items-center justify-between p-4 border-b border-[var(--su-border-primary)]">
              <Link
                to="/docs"
                className="font-semibold text-[var(--su-text-primary)]"
              >
                Docs
              </Link>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 text-[var(--su-text-muted)] hover:text-[var(--su-text-primary)]"
                aria-label="Close navigation"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="overflow-y-auto h-[calc(100vh-4rem)]">
              <DocsSidebar />
            </div>
          </div>
        </>
      )}
    </>
  );
}
